<template>
    <div class="Report" app>
        <Navbar />
        <v-content>
            <v-dialog
                v-model="deleteDialog"
                max-width="600"
            >
                <v-card>
                    <v-card-title class="headline">Você realmente quer deletar esse registro?</v-card-title>

                    <v-card-text>
                        Essa ação é irreversível.
                    </v-card-text>

                    <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn
                            color="red darken-1"
                            text
                            @click="cancel"
                        >
                            Cancelar
                        </v-btn>

                        <v-btn
                            color="green darken-1"
                            text
                            @click="deletar"
                        >
                            Confirmar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <div style="margin: 10px 16px;">
                <v-card style="overflow-x:hidden" flat :dark="customization.dark">
                    <v-card-title>Gestão da Produção e S.O.S</v-card-title>
                    <v-row style="padding: 0px 16px">
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field 
                                label="Data de inicio"
                                v-model="data_inicio"
                                name="data_inicio"
                                :rules="requireRule"
                                type="date"
                                outlined >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field 
                                label="Data de Fim"
                                v-model="data_final"
                                name="data_final"
                                :rules="requireRule"
                                type="date"
                                outlined >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <Autocomplete
                                label="Veículo"
                                name="veiculo"
                                :dark="customization.dark"
                                :needWhere="true"
                                url="getVeiculo"
                                iddisplay="placa"
                                idvalue="idveiculo"
                                :value="veiculo"
                                outlined 
                            ></Autocomplete>
                        </v-col>
                    </v-row>
                    <v-row style="padding: 0px 16px; transform: translateY(-40px)">
                        <v-col sm="12">
                            <v-btn
                                large
                                :color="customization.mainBtnColor"
                                :dark="customization.mainBtnDark"
                                @click="buscar()">
                                Buscar
                            </v-btn>
                            <v-btn
                                style="margin-left: 5px"
                                large
                                color="green"
                                :dark="customization.mainBtnDark"
                                @click="criar()">
                                Criar
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row style="padding: 0px 16px; transform: translateY(-40px)">
                        <v-col cols="12">
                            <v-data-table
                                :headers="headers"
                                :items="items"
                                :loading="loading" 
                                loading-text="Carregando... Por favor espere"
                                class="elevation-1"
                                hide-default-footer
                                :items-per-page="10"
                                :server-items-length="maxPages"
                                :page.sync="page"
                            >
                                <template v-slot:item.actions="{ item }">
                                    <v-icon @click="view(item)">mdi-google-maps</v-icon>
                                    <v-icon @click="select(item)">mdi-pencil</v-icon>
                                    <v-icon @click="del(item)">mdi-delete</v-icon>
                                </template>
                            </v-data-table>
                            <div class="text-center pt-2">
                                <v-pagination :color="customization.mainBtnColor" v-model="pagina" :length="maxPages" total-visible="10" @input="getGrid"></v-pagination>
                            </div>
                        </v-col>
                    </v-row>
                </v-card>
            </div>
        </v-content>
    </div>
</template>

<script>
import Navbar       from '@/components/Navbar.vue';
import Autocomplete from '@/components/Autocomplete.vue';
import api          from '@/plugins/apisauceHeader.js';
import router       from '@/router/index.js';

export default {
    name: 'CRUD',
    components:{
        Navbar,
        Autocomplete
    },
    data: () => ({
        customization: {},
        requireRule: [
            r => (r && r.length > 0 ) || "Essa campo é obrigatório!"
        ],
        data_inicio: null,
        data_final: null,
        veiculo: null,
        maxPages: 1,
        page: 1,
        loading: false,
        items: [],
        pagina: 1,
        headers: [
            { 
                "text": "Veículo", 
                "value": "placa", 
                "sortable": false
            },
            { 
                "text": "Data", 
                "value": "data", 
                "sortable": false
            },
            { 
                "text": "Latitude", 
                "value": "latitude", 
                "sortable": false
            },
            { 
                "text": "Longitude", 
                "value": "longitude", 
                "sortable": false
            },
            { 
                "text": "Carga", 
                "value": "carga", 
                "sortable": false
            },
            { 
                "text": "Area", 
                "value": "area", 
                "sortable": false
            },
            { 
                "text": "Motorista", 
                "value": "motorista", 
                "sortable": false
            },
            { 
                "text": "Situação", 
                "value": "situacao", 
                "sortable": false
            },
            { 
                "text": "Qtd. Carga", 
                "value": "quantidade_carga", 
                "sortable": false
            },
            { 
                "text": "Qtd. Descarga", 
                "value": "quantidade_descarga", 
                "sortable": false
            },
            { 
                "text": "Ações", 
                "value": "actions", 
                "sortable": false
            }
        ],
        deleteDialog: false,
        selection: null
    }),
    methods: {
        buscar(){
            this.pagina = 1;
            this.getGrid();
        },
        criar(){
            router.push("ManagementNew");
        },
        getGrid(){
            let veiculo = null;

            if(!this.data_inicio){
                document.getElementsByName("data_inicio")[0].click();
                return;
            }
            if(!this.data_final){
                document.getElementsByName("data_final")[0].click();
                return;
            }
            if(document.getElementsByName("veiculo")[0].value != "")
                veiculo = document.getElementsByName("veiculo")[0].value;

            const url = veiculo ? 'gestao_prod_veiculo' : 'gestao_prod';
            const urlVeiculo = veiculo ? `idveiculo:${veiculo},` : '';
            
            localStorage.setItem("management",JSON.stringify({
                veiculo,
                data_inicio: this.data_inicio,
                data_final: this.data_final
            }));

            this.loading = true;

            api(localStorage.getItem("token")).get(`endpoint/${url}/addwhere=${urlVeiculo}datainicial:${this.data_inicio},datafinal:${this.data_final}?page=${this.pagina}&orderby=sd.data DESC`).then(r=>{
                if(r.ok){
                    this.items = r.data.endpoint;
                    this.maxPages = r.data.totalPages;
                }
                this.loading = false;
            });
        },
        select(n){
            router.push(`/Management/${n.idsituacaodata}`);
        },
        del(n){
            this.selection = n.idsituacaodata;
            this.deleteDialog = true;
        },
        cancel(){
            this.selection = null;
            this.deleteDialog = false;
        },
        deletar(){
            this.loading = true;
            api(localStorage.getItem("token")).delete(`endpoint/gestao_prod/${this.selection}`).then(r=>{
                if(r.ok)
                    this.getGrid();
                this.loading = false;
                this.deleteDialog = false;
            })
        },
        view(item){
            window.open(`https://www.google.com/maps/search/?api=1&query=${item.latitude},${item.longitude}`,'_blank')
            console.log(item);
        }
    },
    mounted(){
        if(!localStorage.getItem("usrId")) router.push('/');
        this.customization = JSON.parse(localStorage.getItem("customization"));
        document.title = `${this.customization.name} - Gestão da Produção e S.O.S`;

        if(localStorage.getItem("management")){
            const man = JSON.parse(localStorage.getItem("management"));
            this.data_inicio = man.data_inicio;
            this.data_final = man.data_final;
            this.veiculo = man.veiculo;

            const url = man.veiculo ? 'gestao_prod_veiculo' : 'gestao_prod';
            const urlVeiculo = man.veiculo ? `idveiculo:${man.veiculo},` : '';
            
            api(localStorage.getItem("token")).get(`endpoint/${url}/addwhere=${urlVeiculo}datainicial:${man.data_inicio},datafinal:${man.data_final}?page=${this.pagina}`).then(r=>{
                this.items = r.data.endpoint;
                this.maxPages = r.data.totalPages;
            });
        }
    }
}
</script>